<template>
  <div>
    <Privacity></Privacity>
    <Footer></Footer>
  </div>
</template>

<script>
import Privacity from "../components/Privacity";
import Footer from "../components/Footer";

export default {
  name: "App",
  components: {
    Privacity,
    Footer,
  },
};
</script>
